<script>
	import options from './OrderHistoryTable.options'
	export default options
</script>

<template>
	<article class="nlx-order-history-table">

		<div class="nlx-order-history-table__heading-section">
			<h2 class="nlx-order-history-table__heading-title">{{getLabel('orderHistoryTitle')}}</h2>
			<div class="nlx-order-history-table__shown-entry-amount">{{getLabel('shows')}} <span class="nlx-order-history-table__hight-light">{{orderHistoryData.entries.length}}</span> {{getLabel('of')}} <b>{{totalAmountOfEntries}}</b></div>
			<!-- <a :href="orderHistoryData.exportToExcelLink" class="nlx-order-history-table__export-to-excel">{{getLabel('exportToExcel')}}</a> 
				Removed as of Fri 22. April 2022 due to scope
			-->
		</div>

		<TableComponentGeneric :tableData="orderHistoryData"/>

		<div v-if="isAllOrdersShown" class="nlx-order-history-table__show-more-button-container">
			<button @click="showMoreOrders" class="nlx-button nlx-button--black">{{getLabel('show')}} <span class="nlx-order-history-table__hight-light">{{defaultTakeAmount}}</span> {{getLabel('more')}}</button>
		</div>

	</article>
</template>
